import BaseService from './baseService';

export default {
  aprovarRejeitar(qualificacaoTecnica) {
    return BaseService.post("qualificacaoTecnica/aprovarRejeitar",qualificacaoTecnica)
  },
};
